import React from 'react'
import PropTypes from 'prop-types'
import UsersTableRow from './users-table-row'

const tableHeadings = [
  'Twitter handle',
  'Date registered',
  'Active Widgets',
  'Data sets'
]

const UsersTable = ({ users }) => (
  <table className='table table-bordered'>
    <thead>
      <tr>
        {tableHeadings.map(heading => (
          <th className='sorting' key={heading}>
            {heading} <i className='fa fa-sort' />
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {users.map(user => <UsersTableRow key={user.id} {...user} />)}
    </tbody>
  </table>
)

UsersTable.displayName = 'UsersTable'

UsersTable.propTypes = {
  users: PropTypes.array.isRequired
}

export default UsersTable



// WEBPACK FOOTER //
// ./src/pages/admin/users/users-table.js